import type { CasesProps } from "./types";
import CasesCard from "./CasesCard";
import Image from "next/image";

export default function CasesDesktop(props: CasesProps) {
    const { items } = props;

    if (!items?.length) return null;

    return (
        <div className={"flex gap-20 xl:gap-34 py-4 relative"}>
            {items.map((item, i) => {
                let itemClass = "";
                if (i === 1) itemClass = "pt-50";
                if (i === 2) itemClass = "pt-10";

                return (
                    <div key={i} className={itemClass}>
                        <CasesCard item={item} />
                    </div>
                );
            })}

            <Image
                src="/images/cases-top-line.svg"
                alt="card deco"
                width={280}
                height={100}
                sizes="100vw"
                className="absolute top-25 left-1/2 -translate-x-1/2 z-10 w-[48%] lg:w-[46%] xl:w-[50%] h-auto"
            />

            <Image
                src="/images/cases-left-line.svg"
                alt="card deco"
                width={280}
                height={100}
                sizes="100vw"
                className="absolute top-40 left-[27%]  xl:left-70 z-10 w-[8%] lg:w-[9%] xl:w-[12.5%]  h-auto"
            />

            <Image
                src="/images/cases-right-line.svg"
                alt="card deco"
                width={280}
                height={100}
                sizes="100vw"
                className="absolute top-55 left-[64.5%] xl:left-[62.5%] z-10 w-[9%] xl:w-[12.5%] h-auto"
            />
        </div>
    );
}
